import * as React from "react";
import {Fragment} from "react";
import {Col, Input, Row} from "reactstrap";
import {
    alphaNumericValidator,
    alphaSpaceValidator,
    decimalValidator,
    enumValidator,
    longValidator,
    msisdnValidator,
    RequiredFieldTypes,
    stringValidator,
    timeValidator,
    defaultDateValidator
} from "../../../domain/RequiredFieldTypes";
import SFXLoadingComponent from "../../SFXLoadingComponent";
import DatePickerComponent from "../../DatePickerComponent";
import DropdownComponent from "../../DropdownComponent";

export default class InboundRequiredFieldsComponent extends React.Component {

    static FIELD_ID = "required-field-id";
    static FIELD_VALUE = "required-field-value";

    constructor(props) {
        super(props);

        if (props.registerRef) {
            props.registerRef(this)
        }

        this.state = {
            requiredFields: this.props.requiredFields !== undefined ? this.props.requiredFields : [],
            saveBeneficiary: false,
            touchedFields: [],
            inValidFields: [],
            validFields: [],
            formValid: false,
            loading: true
        };

        this.schema = {};
    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader();

        let defaultValues = {};
        let defaultTouchedFields = {};
        let defaultValidFields = {};

        this.state.requiredFields.forEach(requiredField => {
            if (requiredField.dataType === RequiredFieldTypes.ENUM) {
                if (this.props.values !== undefined && this.props.values[requiredField.id]) {
                    defaultValues[requiredField.id] = {
                        "displayValue": this.props.values[requiredField.id],
                        "value": this.props.values[requiredField.id]
                    };
                    defaultTouchedFields[requiredField.id] = true;
                    defaultValidFields[requiredField.id] = true;
                } else {
                    defaultValues[requiredField.id] = {
                        "displayValue": "",
                        "value": ""
                    }
                }
            } else {
                if (this.props.values !== undefined && this.props.values[requiredField.id]) {
                    defaultValues[requiredField.id] = this.props.values[requiredField.id];
                    defaultTouchedFields[requiredField.id] = true;
                    defaultValidFields[requiredField.id] = true;
                } else {
                    defaultValues[requiredField.id] = ""
                }
            }
        });

        this.setState({
            capturedValues: defaultValues,
            touchedFields: defaultTouchedFields,
            validFields: defaultValidFields,
            loading: false
        }, () => this.validateAllRequiredFields());
    }

    handleChange = (event, field) => {

        let capturedValues = {...this.state.capturedValues};
        capturedValues[field] = event.target.value;

        this.setState({
            capturedValues: capturedValues
        }, () => this.validateInputField(field));
    };

    handleDateChange(value, field) {

        let capturedValues = {...this.state.capturedValues};
        capturedValues[field] = value;

        this.setState({
            capturedValues: capturedValues
        }, () => this.validateInputField(field))
    }

    dropdownChange = (event, field) => {

        let capturedValues = {...this.state.capturedValues};

        if (event === null) {
            capturedValues[field] = {
                "displayValue": "",
                "value": ""
            }
        } else {
            capturedValues[field] = {
                "displayValue": event.displayValue,
                "value": event.value
            }
        }

        this.setState({
            capturedValues: capturedValues
        }, () => this.validateInputField(field));
    };

    hasBeenTouched(field) {

        let previousTouched = {...this.state.touchedFields};
        previousTouched[field] = true;

        this.setState({
                touchedFields: previousTouched
            }, () => this.validateInputField(field)
        )
    }

    getValues() {

        let capturedFields = [];

        this.state.requiredFields.forEach(requiredField => {
            let singleCapturedFields = {};
            singleCapturedFields[InboundRequiredFieldsComponent.FIELD_ID] = requiredField.id;
            singleCapturedFields[InboundRequiredFieldsComponent.FIELD_VALUE] = this.state.capturedValues[requiredField.id].value !== undefined ? this.state.capturedValues[requiredField.id].value : this.state.capturedValues[requiredField.id];
            capturedFields.push(singleCapturedFields);
        });

        return capturedFields;
    }

    validateInputField(field) {

        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state.capturedValues[field].displayValue !== undefined ? this.state.capturedValues[field].displayValue : this.state.capturedValues[field];

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).then(() => {
                    this.validateAllRequiredFields();
                }).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];

                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    }, () => self.validateAllRequiredFields());
                })
            }
        })
    }

    validateAllRequiredFields() {

        let formValid = true;

        this.state.requiredFields.forEach(requiredField => {
            if (this.state.validFields[requiredField.id] === undefined) {
                formValid = false;
            }
        });

        if (this.state.formValid !== formValid) {
            this.setState({
                formValid: formValid
            }, () => this.props.isValid(formValid));
        }
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>

            <div>
                {this.state.requiredFields.map((requiredField, index) => {
                    switch (requiredField.dataType) {
                        case RequiredFieldTypes.STRING:
                            this.schema[requiredField.id] = stringValidator(requiredField.id, requiredField.displayName, true, 1);
                            return this.renderInput(this.props.className, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.DECIMAL:
                            this.schema[requiredField.id] = decimalValidator(requiredField.id, requiredField.displayName, true, 2, true);
                            return this.renderInput(this.props.className, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.ENUM:
                            this.schema[requiredField.id] = enumValidator(requiredField.id, requiredField.displayName, true);
                            let enumDropdownOptions = requiredField["possibleValues"];
                            return this.renderDropdown(this.props.className, enumDropdownOptions, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.LONG:
                            this.schema[requiredField.id] = longValidator(requiredField.id, requiredField.displayName, true, true);
                            return this.renderInput(this.props.className, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.DATE:
                            this.schema[requiredField.id] = defaultDateValidator(requiredField.id, requiredField.displayName, true);
                            return this.renderDatePicker(this.props.className, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.TIME:
                            this.schema[requiredField.id] = timeValidator(requiredField.id, requiredField.displayName, true);
                            return this.renderTimeInput(this.props.className, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.ALPHA_SPACE:
                            this.schema[requiredField.id] = alphaSpaceValidator(requiredField.id, requiredField.displayName, true);
                            return this.renderInput(this.props.className, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.MSISDN:
                            this.schema[requiredField.id] = msisdnValidator(requiredField.id, requiredField.displayName, true);
                            return this.renderInput(this.props.className, requiredField.id, requiredField.displayName, index);

                        case RequiredFieldTypes.ALPHA_NUMERIC:
                            this.schema[requiredField.id] = alphaNumericValidator(requiredField.id, requiredField.displayName, true);
                            return this.renderInput(this.props.className, requiredField.id, requiredField.displayName, index);
                        default:
                            return <Fragment/>
                    }
                })}

                {/*{this.props.saveBeneficiary === undefined && this.renderTickBox(this.props.className)}*/}
            </div>

        </Fragment>
    }

    renderTimeInput(className, field, text, index) {

        return <Fragment key={index}>

            <Row className={className + "_row"}>
                <Col>
                    <Input
                        className={className + "_input"}
                        type={"time"}
                        value={this.state.capturedValues[field] || ""}
                        placeholder={text}
                        id={field}
                        onChange={(event) =>
                            this.handleChange(event, field)
                        }
                        onBlur={() => this.hasBeenTouched(field)}
                    />
                    {this.state.inValidFields[field] && this.renderErrorMessage(className, field, this.state.inValidFields[field])}
                </Col>
            </Row>

        </Fragment>

    }

    renderInput(className, field, text, index) {

        return <Fragment key={index}>

            <Row className={className + "_row"}>
                <Col>
                    <Input
                        className={className + "_input"}
                        value={this.state.capturedValues[field] || ""}
                        placeholder={text}
                        id={field}
                        onChange={(event) => this.handleChange(event, field)}
                        onBlur={() => this.hasBeenTouched(field)}
                    />
                    {this.state.inValidFields[field] && this.renderErrorMessage(className, field, this.state.inValidFields[field])}
                </Col>
            </Row>

        </Fragment>

    }

    renderDatePicker(className, field, text, index) {

        return <Fragment key={index}>

            <Row className={className + "_row"}>
                <Col>
                    <DatePickerComponent
                        inputStyle={className + "_input"}
                        onChange={(value) => {
                            this.handleDateChange(value, field)
                        }}
                        firstTouch={() => this.hasBeenTouched(field)}
                        value={this.state.capturedValues[field]}
                        placeholder={text}
                    />
                    {this.state.inValidFields[field] && this.renderErrorMessage(className, field, this.state.inValidFields[field])}
                </Col>
            </Row>

        </Fragment>

    }

    renderDropdown(className, dropdownOptions, field, text, index) {

        return <Fragment key={index}>

            <Row className={className + "_row"}>
                <Col>
                    <DropdownComponent
                        className={className + "_dropdown"}
                        value={this.state.capturedValues[field] !== undefined ? this.state.capturedValues[field]["value"] : ""}
                        options={dropdownOptions}
                        optionValue={"value"}
                        optionText={"displayValue"}
                        placeholder={text}
                        onChange={(selectedOption) => {
                            this.dropdownChange(selectedOption, field)
                        }}
                        clearable={true}
                        onBlur={() => this.hasBeenTouched(field)}
                    />
                    {this.state.inValidFields[field] && this.renderErrorMessage(className, field, this.state.inValidFields[field])}
                </Col>
            </Row>

        </Fragment>
    }

    renderErrorMessage(className, field, message) {
        return <h6 className={className + "_error_text"}>
            {message}
        </h6>;
    }

}